module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "mainDiv"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.upShow),
      expression: "upShow"
    }],
    staticClass: "leftDiv"
  }, [(_vm.box) ? _c('div', {
    staticClass: "boxDiv"
  }, [_vm._v("文件夹："), _c('a', {
    attrs: {
      "href": 'http://jazpan.com/box/' + _vm.box.Id,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.box.Name))]), _vm._v(" "), _c('el-link', {
    attrs: {
      "type": "danger",
      "icon": "el-icon-circle-close",
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.clearBox()
      }
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "btnQr",
    attrs: {
      "src": "//static.jazpan.com/img/qrcode.png"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.qrcoder.show('https://jazpan.com/box/' + _vm.box.Id, 'https://m.jazpan.com/xcx/qrgoto/box?' + _vm.box.Id)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('Upload', {
    attrs: {
      "boxid": _vm.boxid
    },
    on: {
      "okfun": function($event) {
        return _vm.getList()
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    ref: "rightDiv",
    staticClass: "rightDiv",
    style: ('width:' + _vm.upShowRW)
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.listQuery
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.handleHide
    }
  }, [_vm._v(_vm._s(_vm.upShow ? '隐藏' : '显示') + "上传面板")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "搜索"
    },
    model: {
      value: (_vm.listQuery.q),
      callback: function($$v) {
        _vm.$set(_vm.listQuery, "q", $$v)
      },
      expression: "listQuery.q"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.getList();
        _vm.getBoxList();
      }
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button-group', [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.fileSelForm.show(_vm.boxid)
      }
    }
  }, [_vm._v("添加文件")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "warning"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.boxSelForm.show(_vm.boxid)
      }
    }
  }, [_vm._v("添加文件夹")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onKeySortFun
    }
  }, [_vm._v("一键排序文件")])], 1)], 1)], 1), _vm._v(" "), (_vm.tableData.length > 100 || _vm.boxlistData.length > 100) ? _c('div', {
    staticClass: "tips"
  }, [_vm._v("提示: 文件夹只能显示100个文件，超过的部分将不会显示出来")]) : _vm._e(), _vm._v(" "), (_vm.boxlistData.length > 0) ? _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.boxlistLoading),
      expression: "boxlistLoading"
    }],
    ref: "boxdataTable",
    attrs: {
      "data": _vm.boxlistData,
      "element-loading-text": "Loading",
      "border": "",
      "highlight-current-row": ""
    },
    on: {
      "sort-change": _vm.changeSortFun
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "状态",
      "align": "center",
      "width": "100px"
    }
  }, [
    [_c('span', [_vm._v("正常")])]
  ], 2), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "文件夹",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [(row.Status < 1) ? _c('span', [_vm._v(_vm._s(row.Name))]) : _c('a', {
          attrs: {
            "href": 'http://jazpan.com/box/' + row.Id,
            "target": "_blank"
          }
        }, [_c('img', {
          staticClass: "flicon",
          attrs: {
            "src": "//static.jazpan.com/img/flbox.png"
          }
        }), _vm._v("\n              " + _vm._s(row.Name) + "\n            ")])]
      }
    }], null, false, 490592504)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "时间",
      "align": "center",
      "width": "160px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('span', [_vm._v(_vm._s(row.Timestr))])]
      }
    }], null, false, 790294596)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Sort",
      "label": "排序",
      "align": "center",
      "width": "50px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "width": "250px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('img', {
          staticClass: "btnQr",
          attrs: {
            "src": "//static.jazpan.com/img/qrcode.png"
          },
          on: {
            "click": function($event) {
              return _vm.$refs.qrcoder.show('https://jazpan.com/box/' + row.Id, 'https://m.jazpan.com/xcx/qrgoto/box?' + row.Id)
            }
          }
        }), _vm._v(" "), (row.Canedit) ? _c('el-link', {
          staticClass: "btnTxt",
          attrs: {
            "type": "primary",
            "underline": false
          },
          on: {
            "click": function($event) {
              return _vm.inits(row.Xid)
            }
          }
        }, [_vm._v("管理")]) : _vm._e(), _vm._v(" "), _c('el-link', {
          staticClass: "btnTxt",
          attrs: {
            "type": "primary",
            "underline": false
          },
          on: {
            "click": function($event) {
              return _vm.$refs.boxSelfForm.show(row)
            }
          }
        }, [_vm._v("排序")]), _vm._v(" "), _c('el-link', {
          staticClass: "btnTxt",
          attrs: {
            "type": "warning",
            "underline": false
          },
          on: {
            "click": function($event) {
              return _vm.rmBoxFun(row.Prtid, row.Xid)
            }
          }
        }, [_vm._v("移除")])]
      }
    }], null, false, 4287312606)
  })], 1) : _vm._e(), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    ref: "dataTable",
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "data": _vm.tableData,
      "element-loading-text": "Loading",
      "border": "",
      "highlight-current-row": ""
    },
    on: {
      "sort-change": _vm.changeSortFun
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "状态",
      "align": "center",
      "width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('span', [_vm._v(_vm._s(row.Stats))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "文件名",
      "align": "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [(row.Status < 1) ? _c('span', [_vm._v(_vm._s(row.Name))]) : _c('a', {
          attrs: {
            "href": 'http://jazpan.com/view/' + row.Id,
            "target": "_blank"
          }
        }, [_c('img', {
          staticClass: "flicon",
          attrs: {
            "src": _vm.$ApiUrl + '/icon?name=' + row.Extion
          }
        }), _vm._v("\n              " + _vm._s(row.Name) + "\n            ")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "金额",
      "align": "center",
      "width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('span', {
          staticStyle: {
            "color": "#f60",
            "font-weight": "bold"
          }
        }, [_vm._v(_vm._s(row.Amounts))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "大小",
      "align": "center",
      "width": "120px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('span', [_vm._v(_vm._s(_vm.getFlSize(row.Size)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Downs",
      "label": "下载",
      "align": "center",
      "width": "80px",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "时间",
      "align": "center",
      "width": "160px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('span', [_vm._v(_vm._s(row.Timestr))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Sort",
      "label": "排序",
      "align": "center",
      "width": "50px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "width": "250px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('img', {
          staticClass: "btnQr",
          attrs: {
            "src": "//static.jazpan.com/img/qrcode.png"
          },
          on: {
            "click": function($event) {
              return _vm.$refs.qrcoder.show('https://jazpan.com/view/' + row.Id, 'https://m.jazpan.com/xcx/qrgoto/file?' + row.Id)
            }
          }
        }), _vm._v(" "), (row.Canedit) ? _c('i', {
          staticClass: "btnQr el-icon-edit-outline",
          staticStyle: {
            "color": "#db3939"
          },
          on: {
            "click": function($event) {
              return _vm.$refs.fileEdit.show(row)
            }
          }
        }) : _vm._e(), _vm._v(" "), (row.Canedit) ? _c('i', {
          staticClass: "btnQr el-icon-delete",
          staticStyle: {
            "color": "#db3939"
          },
          on: {
            "click": function($event) {
              return _vm.delFun(row.Xid)
            }
          }
        }) : _vm._e(), _vm._v(" "), _c('el-link', {
          staticClass: "btnTxt",
          attrs: {
            "type": "primary",
            "underline": false
          },
          on: {
            "click": function($event) {
              return _vm.$refs.boxflEdit.show(row)
            }
          }
        }, [_vm._v("排序")]), _vm._v(" "), _c('el-link', {
          staticClass: "btnTxt",
          attrs: {
            "type": "warning",
            "underline": false
          },
          on: {
            "click": function($event) {
              return _vm.rmFun(row.Boxid, row.Xid)
            }
          }
        }, [_vm._v("移除")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "right",
      "margin-top": "50px"
    }
  })], 1), _vm._v(" "), _c('FileEdit', {
    ref: "fileEdit",
    on: {
      "submitOK": function($event) {
        return _vm.getList()
      }
    }
  }), _vm._v(" "), _c('BoxFileForm', {
    ref: "boxflEdit",
    on: {
      "submitOK": function($event) {
        return _vm.getList()
      }
    }
  }), _vm._v(" "), _c('BoxSelfForm', {
    ref: "boxSelfForm",
    on: {
      "submitOK": function($event) {
        return _vm.getBoxList()
      }
    }
  }), _vm._v(" "), _c('FileSelForm', {
    ref: "fileSelForm",
    on: {
      "submitOK": function($event) {
        return _vm.getList()
      }
    }
  }), _vm._v(" "), _c('BoxSelForm', {
    ref: "boxSelForm",
    on: {
      "submitOK": function($event) {
        return _vm.getBoxList()
      }
    }
  }), _vm._v(" "), _c('Qrcode', {
    ref: "qrcoder"
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23e323a3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/ruis/file/BoxFileList.vue
// module id = 1155
// module chunks = 1